import React, { useState } from 'react';

// Material UI
import { useTheme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

// Template
import AuthService from 'HammerTemplate/Authentication/AuthService';

function CUIWarning() {
    return (
        <DialogContent dividers>
            <Typography paragraph={true} align="center">
                All individuals using this application and it's associated
                content are required to protect it from unauthorized disclosure.
            </Typography>
            <Typography paragraph={true} align="center">
                Handling, storage, reproduction, and disposition of the
                application content must be in accordance with 32 CFR Part 2002
                and applicable agency policy.
            </Typography>
            <Typography paragraph={true} align="center">
                Access to and the dissemination of Controlled Unclassified
                Information shall be allowed as necessary and permissable to any
                individual(s), organization(s) or grouping(s) of users, provided
                such access or dissemination is consistent with or in
                furtherance of Lawful Government Purpose and in a manner
                consistent with applicable law, regulations, and government-wide
                policies.
            </Typography>
            <Stack
                justifyContent="center"
                alignItems="center"
                sx={{ backgroundColor: 'indigo', padding: '2rem' }}
            >
                <Typography textAlign={'center'} variant="h1" color="white">
                    CUI
                </Typography>
            </Stack>
        </DialogContent>
    );
}

function GovernmentWarning() {
    return (
        <DialogContent dividers>
            <Typography paragraph={true} align="center">
                <b>System Use Statement</b>
            </Typography>
            <Typography paragraph={true} align="center">
                You are accessing a U.S. Government information system. This
                information system is provided for U.S. Government-authorized
                use. Unauthorized or improper use of this system may result in
                disciplinary action and civil and criminal penalties.
            </Typography>
            <Typography paragraph={true} align="center">
                By using this information system, you understand and consent to
                the following: You have no reasonable expectation of privacy
                regarding any requests transmitted through or data stored on
                this information system. At any time, the government may
                monitor, intercept, search, and/or seize data transmitted or
                stored on this information system. Any communication transmitted
                through or data stored on this information system may be
                disclosed or used for any U.S Government-authorized purpose
            </Typography>

            <Typography paragraph={true} align="center">
                <b>Technology Use Statement</b>
            </Typography>
            <Typography paragraph={true} align="center">
                Engineering services are intended to be used for LEAD PURPOSES
                ONLY. Return data is not intended to be introduced as evidence
                in court, as the technical trade-craft is LES (preserving its
                use across all investigative programs).
            </Typography>
        </DialogContent>
    );
}

const GOVERNMENT_WARNING: boolean =
    process.env.REACT_APP_GOVERNMENT_WARNING === 'true';

function WarningPage() {
    const theme = useTheme();
    const [accepted, setAccepted] = useState<boolean>(false);

    return (
        <Dialog
            open={!accepted}
            fullWidth
            slotProps={{
                backdrop: {
                    style: { backgroundColor: theme.palette.primary.main },
                },
            }}
        >
            <DialogTitle textAlign={'center'} variant="h3">
                ATTENTION
            </DialogTitle>
            {GOVERNMENT_WARNING ? <GovernmentWarning /> : <CUIWarning />}
            <DialogActions>
                <Stack
                    sx={{ width: '100%' }}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Button
                        variant="contained"
                        onClick={() => AuthService.doLogout()}
                    >
                        Log Out
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => setAccepted(true)}
                    >
                        Accept
                    </Button>
                </Stack>
            </DialogActions>
        </Dialog>
    );
}

export default WarningPage;
